<script setup>
  import { ref, computed, watchEffect } from 'vue';
  import PopupMenu from "@/components/controls/PopupMenu.vue";
  import Icon from "@/components/icons/Icon.vue";

  const emit = defineEmits(['popup:toggle']);

  const props = defineProps({
    id: {
      type: [String, Number],
      required: true
    },
    icon: {
      type: String,
    },
    iconSubtle: {
      type: Boolean,
      default: false
    },
    closePopup: {
      type: Boolean,
      default: false
    },
    positionY: {
      type: String,
      default: 'top'
    },
    positionX: {
      type: String,
      default: 'right'
    },
    hideDivider: {
      type: Boolean,
      default: true
    },
    menuClass: {
      type: String,
      default: ''
    },
    buttonClass: {
      type: String,
      default: ''
    },
    usePopupButtonClass: {
      type: Boolean,
      default: true
    },
    buttonSize: {
      type: String,
      default: 'normal'
    },
    textButton: {
      type: Boolean,
      default: false
    },
    paddingOff: {
      type: Boolean,
      default: false
    }
  });

  
  let showMenu = ref(false);
  let popupButton = ref(null);

  const buttonClasses = computed(() => props.usePopupButtonClass ? `jwx-popup__button ${props.buttonClass}` : props.buttonClass);

  const togglePopupMenu = () => { showMenu.value ? closePopupMenu() : showPopupMenu() }
  
  async function showPopupMenu() {
    showMenu.value = true;
    emit('popup:toggle', showMenu.value);
  }
  
  function closePopupMenu() {
    showMenu.value = false;
    emit('popup:toggle', showMenu.value);
  };

  watchEffect(() => props.closePopup && closePopupMenu());
</script>
<template>
  <div
    @keyup.esc="escapeMenu"
    class="jwx-popup"
    :class="[{'jwx-popup--text-button': props.textButton, 'jwx-popup--divider-off': props.hideDivider, 'jwx-popup--padding-off': props.paddingOff}]"
  >
    <button
      type="button"
      @click="togglePopupMenu"
      :aria-controls="`popup-menu-${id}`"
      :aria-expanded="showMenu"
      :class="buttonClasses"
      :data-size="props.buttonSize"
      ref="popupButton"
    >
      <slot name="icon">
        <Icon :name="icon" class="jwx-popup__icon" :data-icon-subtle="props.iconSubtle" />
        <span class='sr-only'>Container Action Menu</span>
      </slot>
    </button>
    <slot name="misc"></slot>
      <slot name="menu">
        <PopupMenu
          v-if="showMenu"
          v-model="showMenu"
          :id="`popup-menu-${id}`"
          :positionX="props.positionX"
          :class="props.menuClass"
          :data-pos-y="props.positionY"
          :data-pos-x="props.positionX"
          :button="popupButton"
        >

          <slot name="default" :showMenu="showMenu"></slot>
        </PopupMenu>
      </slot>
  </div>
</template>